import { render, staticRenderFns } from "./PageTabMenu.vue?vue&type=template&id=47d17206&"
import script from "./PageTabMenu.vue?vue&type=script&lang=ts&"
export * from "./PageTabMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports